
/**
 * Main entry point for distance mappings
 */
import { getPuttingTestDistances } from './putting';
import { getChippingDistances } from './chipping';
import { getWedgingDistances } from './wedging';
import { getBunkerDistances } from './bunker';
import { getIronDistances, getFairwayWoodDistances, getDriverDistances } from './clubs';

export const getTestDistances = (testId: string): Record<string, string> => {
  console.log("getTestDistances called for:", testId);
  
  // First check driver tests (common prefix)
  if (testId.startsWith('driver-')) {
    return getDriverDistances(testId);
  }
  
  // Check which level we're in
  const pathname = window.location.pathname;
  const isLevel1 = pathname.includes('level1');
  const isLevel2 = pathname.includes('level2');
  
  console.log("getTestDistances - pathname:", pathname);
  console.log("getTestDistances - isLevel1:", isLevel1);
  console.log("getTestDistances - isLevel2:", isLevel2);
  
  // Obtenir les distances en fonction du type de test
  let distances: Record<string, string> = {};
  
  if (testId.includes('putts')) {
    distances = getPuttingTestDistances(testId);
  } else if (testId.includes('chipping')) {
    distances = getChippingDistances(testId);
  } else if (testId.includes('wedging')) {
    distances = getWedgingDistances(testId);
  } else if (testId.includes('bunker')) {
    distances = getBunkerDistances(testId);
  } else if (testId.includes('iron')) {
    distances = getIronDistances(testId);
  } else if (testId.includes('fairwayWood')) {
    distances = getFairwayWoodDistances(testId);
  } else {
    // Return empty object for unknown test ID
    console.warn(`Unknown test ID for distances: ${testId}`);
  }
  
  console.log("getTestDistances - returning distances:", distances);
  return distances;
};
